import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 max-w-6xl mx-auto px-6 pt-4 pb-10">
      <div className="glass rounded-3xl p-8 md:p-10">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="Florida AI Marketing Experts"
                className="h-10 w-10 rounded-full object-cover"
              />
              <div className="h-display text-xl leading-tight">
                Florida <span style={{ color: '#0D9488' }}>AI</span> Marketing Experts
              </div>
            </div>
            <p className="mt-4 text-slate-600 font-body font-light text-sm max-w-md leading-relaxed">
              AI-first marketing for Florida home service contractors. Get recommended by ChatGPT,
              dominate generative search, and capture every lead with Voice AI.
            </p>
            <div className="mt-5 space-y-2 text-sm text-slate-700 font-body">
              <div className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-teal-500"></i>(954) 296-4896
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-500"></i>Plantation, FL 33324
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <div className="text-[11px] uppercase tracking-wider text-slate-400 font-body font-bold mb-3">
              The Three Pillars
            </div>
            <ul className="space-y-2 text-slate-700 font-body font-light text-sm">
              <li><Link to="/chatgpt-ads" className="hover:text-teal-500 transition-colors">ChatGPT Ads</Link></li>
              <li><Link to="/geo" className="hover:text-teal-500 transition-colors">Generative Engine Optimization</Link></li>
              <li><Link to="/voice-ai" className="hover:text-teal-500 transition-colors">Voice AI Agents</Link></li>
              <li><Link to="/services" className="hover:text-teal-500 transition-colors">All Services</Link></li>
            </ul>
          </div>

          {/* Explore */}
          <div>
            <div className="text-[11px] uppercase tracking-wider text-slate-400 font-body font-bold mb-3">
              Explore
            </div>
            <ul className="space-y-2 text-slate-700 font-body font-light text-sm">
              <li><Link to="/industries" className="hover:text-teal-500 transition-colors">Who We Help</Link></li>
              <li><Link to="/service-areas" className="hover:text-teal-500 transition-colors">Service Areas</Link></li>
              <li><Link to="/case-studies" className="hover:text-teal-500 transition-colors">Case Studies</Link></li>
              <li><Link to="/calculators" className="hover:text-teal-500 transition-colors">Free Tools</Link></li>
              <li><Link to="/audit" className="hover:text-teal-500 transition-colors">Free AI Check</Link></li>
              <li><Link to="/contact" className="hover:text-teal-500 transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-slate-400 text-xs font-body">
            © {currentYear} Florida AI Marketing Experts · Plantation, FL
          </div>
          <div className="flex gap-5 text-slate-400 text-xs font-body">
            <Link to="/privacy" className="hover:text-teal-500 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-teal-500 transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-teal-500 transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
